import { Pipe, PipeTransform } from '@angular/core';

/**
 * Generated class for the FormatMilesTypeValuePipe pipe.
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'formatMilesTypeValue',
})
export class FormatMilesTypeValuePipe implements PipeTransform {
  /**
   * Takes a job and computes what the "miles type" value should read based on
   *   the following fields:
   *    milesPerWeekRange: { type: Boolean, default: false },
   *    milesPerWeek:     { type: String, default: 0 },
   *    milesPerWeekMin:  { type: String, default: 0 },  // (for range)
   *    milesPerWeekMax:  { type: String, default: 0 },  // (for range)
   *    milesPerMonthRange: { type: Boolean, default: false },
   *    milesPerMonth:    { type: String, default: 0 },
   *    milesPerMonthMin: { type: String, default: 0 },  // (for range)
   *    milesPerMonthMax: { type: String, default: 0 },  // (for range)
   *    milesPerPlus:     { type: Boolean, default: false }, // (100+ or just 100)
   *    milesUpTo:        { type: Boolean, default: false },
   *    milesType:        { type: String, enum: ENUMS.milesType },
   */

  comma = function(value) {
    let str = String(value).replace(/[^0-9]/g, ''),
      d = Number(str) || 0;
    return d.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  };

  transform(job: any, ...args) {
    let s = '';

    if (job.milesType === 'milesperweek') {
      // weekly range (e.g. 1,000 - 3,000 per week)
      if (job.milesPerWeekRange) {
        s += this.comma(job.milesPerWeekMin);
        s += ' - ';
        s += this.comma(job.milesPerWeekMax);
        // e.g. 1,000 - 3,000+ miles per week
        if (job.milesPerPlus) {
          s += '+';
        }
        s += ' per week';
        return s;
      }
      // weekly fixed (e.g. 3,000 per week)
      else {
        // e.g. Up to 3,000 miles per week
        if (job.milesUpTo) {
          s += 'Up to ';
        }
        s += this.comma(job.milesPerWeek);
        // e.g. 3,000+ miles per week
        if (job.milesPerPlus) {
          s += '+';
        }
        s += ' per week';
        return s;
      }
    } else if (job.miles === 'milespermonth') {
      // monthly range (e.g. 1,000 - 3,000 per month)
      if (job.milesPerMonRange) {
        s += this.comma(job.milesPerMonthMin);
        s += ' - ';
        s += this.comma(job.milesPerMonthMax);
        // e.g. 1,000 - 3,000+ miles per month
        if (job.milesPerPlus) {
          s += '+';
        }
        s += ' per month';
        return s;
      }
      // monthly fixed (e.g. 3,000 per month)
      else {
        // e.g. Up to 3,000 miles per month
        if (job.milesUpTo) {
          s += 'Up to ';
        }
        s += this.comma(job.milesPerMonth);
        // e.g. 3,000+ miles per week
        if (job.milesPerPlus) {
          s += '+';
        }
        s += ' per month';
        return s;
      }
    } else if (
      job.miles === 'calltodiscuss' ||
      job.milesType === 'calltodiscuss'
    ) {
      return 'Call to Discuss';
    } else {
      return 'Call to Discuss';
    }
  }
}



// WEBPACK FOOTER //
// ./src/pipes/format-miles-type-value/format-miles-type-value.ts